import React from "react";
import CheckList, { CheckListItem } from "../../components/CheckList";
import { TRUSTPILOT } from "../../constants";

/**
 * The promises shown beside a quote, matched to what the client T&Cs actually say for the case type:
 * sellers pay only on completion, buyers get the second chance guarantee. Shared by the organic,
 * referrer and broker quote pages so the three cannot drift.
 */
function QuoteGuarantees({ transactionType }) {
  const selling = transactionType === "Selling" || transactionType === "BuyingAndSelling";
  const buying = transactionType === "Buying" || transactionType === "BuyingAndSelling";
  return (
    <CheckList>
      {selling && (
        <CheckListItem>
          {transactionType === "BuyingAndSelling"
            ? "You only pay for your sale when it completes"
            : "You only pay when your sale completes"}
        </CheckListItem>
      )}
      {buying && (
        <CheckListItem>Second chance guarantee: if this purchase falls through, your next one is covered</CheckListItem>
      )}
      <CheckListItem>No hidden fees</CheckListItem>
      <CheckListItem>{TRUSTPILOT.ratingText}</CheckListItem>
    </CheckList>
  );
}

export default QuoteGuarantees;
